import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { maskDate } from "../utils/Masker";
import axios from 'axios';
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;

export const OPCOES_COMBO = [
  {
    key: 'E',
    label: 'Entrada'
  },
  {
    key: 'S',
    label: 'Saída'
  },
]

export const OPCOES_COMBO_PARC = [
  {
    key: 'A',
    label: 'ABERTO'
  },
  {
    key: 'P',
    label: 'PAGO'
  },
]

export default class TituloParcelaForm extends Component {
  state = {
    editando: false,
    formParcDisabled: true,
    condInformada: false,

    listaParcelas: [],
    valor_Total: 0,
    vlrTotalParc: 0,
    vlrDifParc: 0,

    registroParcela: {
      vp_parcela: 0,
      vp_data_parcela: moment().format('DD/MM/YYYY'),
      vp_valor_parcela: 0,
    }
  };


  componentDidUpdate(propsAnterior) {
    if (this.props !== propsAnterior) {
      // console.log('componentDidUpdate: ', this.props);

      this.setState({
        // registro: this.props.registroSelecionado.dados,
        listaParcelas: this.props.listaParcelas ? this.props.listaParcelas : [],
        valor_Total: this.props.valor_Total ? this.props.valor_Total : [],
        condInformada: this.props.condPagto && this.props.condPagto.key === String(this.state.usuario.par_cond_pagto_informada) ? true : false,
        registroParcela: {
          vp_parcela: 0,
          vp_data_parcela: moment().format('DD/MM/YYYY'),
          vp_valor_parcela: 0,
        }

      }, () => {

      });
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  onDateVencChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registroParcela } = this.state;
    registroParcela['vp_data_parcela'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ vp_data_parcela: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onDatePagtoChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registroParcela } = this.state;
    registroParcela['pgto_data'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ pgto_data: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }



  onChangeParcela = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroParcela } = this.state;
    registroParcela[id] = value;
    this.setState({ [id]: value });
  };

  onChangeSituacaoParcela = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroParcela } = this.state;
    registroParcela[id] = value;
    this.setState({ [id]: value });
    this.calculaVlrParc(value);
  };

  onChangeValorParcela = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroParcela } = this.state;
    registroParcela[id] = value;
    this.setState({
      [id]: value
    });
  };

  calculaVlrParc = (situacao) => {
    let pgto_vlr_pago = this.state.registroParcela.vp_valor_parcela;
    if (situacao.key === 'P') {
      pgto_vlr_pago = (parseFloat(this.state.registroParcela.vp_valor_parcela) + parseFloat(this.state.registroParcela.pgto_vlr_acrescimo) - parseFloat(this.state.registroParcela.pgto_vlr_desconto)).toFixed(2);
    }
    this.setState({
      registroParcela: {
        ...this.state.registroParcela,
        pgto_vlr_acrescimo: situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_acrescimo : 0,
        pgto_vlr_desconto: situacao.key === 'P' ? this.state.registroParcela.pgto_vlr_desconto : 0,
        pgto_vlr_pago,
      }
    });

  }

  onAdicionarClick = registro => {
    let registroParcela = {
      vp_parcela: this.state.listaParcelas.length + 1,
      vp_data_parcela: moment().format('DD/MM/YYYY'),
      vp_valor_parcela: 0,
    }
    this.setState({
      registroParcela,
      formParcDisabled: false,
      activeKey: "parcela",
    });
  }

  onOKParcClick = (value) => {
    // console.log('this.state.registroParcela: ', this.state.registroParcela);

    if ((this.state.registroParcela.vp_valor_parcela) && (parseFloat(this.state.registroParcela.vp_valor_parcela) < 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Valor da Parcela menor que zero.', });
      return;
    }

    const iInd = this.state.listaParcelas ? this.state.listaParcelas.findIndex(registro => String(registro.vp_parcela) === String(this.state.registroParcela.vp_parcela)) : -1;

    if (iInd >= 0) {

      this.state.listaParcelas[iInd].vp_data_parcela = moment(this.state.registroParcela.vp_data_parcela, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.state.listaParcelas[iInd].vp_valor_parcela = this.state.registroParcela.vp_valor_parcela;

    } else {

      this.state.listaParcelas.push({
        vp_parcela: this.state.registroParcela.vp_parcela,
        vp_data_parcela: moment(this.state.registroParcela.vp_data_parcela, 'DD/MM/YYYY').format('YYYY-MM-DD'),
        vp_valor_parcela: this.state.registroParcela.vp_valor_parcela,
      });

    }


    this.setState({
      formParcDisabled: true,

      registroParcela: {
        vp_parcela: 0,
        vp_data_parcela: moment().format('DD/MM/YYYY'),
        vp_valor_parcela: 0,
      }
    },
      this.calculaTotalParc()
    );

  };

  onEditarParcelaClick = registro => {
    // console.log('PARCELA: ', registro);
    let registroParcela = {
      vp_parcela: registro.vp_parcela,
      vp_data_parcela: moment(registro.vp_data_parcela, 'YYYY-MM-DD').format('DD/MM/YYYY'),
      vp_valor_parcela: registro.vp_valor_parcela,
    }
    this.setState({
      registroParcela,
      formParcDisabled: false,
    });

  };

  onCancelarParcClick = (value) => {
    this.setState({
      formParcDisabled: true,
      registroParcela: {
        vp_parcela: 0,
        vp_data_parcela: moment().format('DD/MM/YYYY'),
        vp_valor_parcela: 0,
      }
    });
  };

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].vp_valor_parcela);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.props.valor_Total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }



  renderValor = (vp_valor_parcela) => {
    return (
      <span> {numeral(parseFloat(vp_valor_parcela)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  renderAcoesParcelas = (registro) => {
    return (
      <Tooltip title="Editar">
        <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarParcelaClick(registro)} icon="edit" />
      </Tooltip>
    );
  };





  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------


  render() {
    const { onFecharClick, visivel } = this.props;
    const { vp_parcela, vp_data_parcela, vp_valor_parcela } = this.state.registroParcela;
    const { valor_Total, listaParcelas, vlrTotalParc, vlrDifParc, formParcDisabled, condInformada } = this.state;

    // console.log('TituloParcelaForm.this.state: ', this.state);

    return (
      <Modal
        title={"Editar Parcelas"}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharClick}
        footer={null}
        width={"50%"}
        style={{ top: 10 }}
      >
        <div>
          <Row style={{}}>
            <Row style={{}}>
              <Col xs={24} sm={8} className="camposEspacoDireita">
                <span>Parcela</span>
                <InputForm
                  id="vp_parcela"
                  ref="vp_parcela"
                  onChange={this.onChangeParcela}
                  value={vp_parcela}
                  disabled={true}
                />
              </Col>
              <Col xs={24} sm={8} style={{ marginTop: 4 }} className="camposEspacoDireita">
                <span>Data Vencimento</span>
                <DatePicker
                  onChange={this.onDateVencChange}
                  format="DD/MM/YYYY"
                  showToday={true}
                  value={moment(vp_data_parcela, "DD/MM/YYYY", true)}
                  style={{ width: "100%" }}
                />
              </Col>
              <Col xs={24} sm={8} style={{ marginTop: 2 }}>
                <span>Valor Parcela</span>
                <InputForm
                  type="number"
                  id="vp_valor_parcela"
                  ref="vp_valor_parcela"
                  value={vp_valor_parcela}
                  onChange={this.onChangeValorParcela}
                />
              </Col>
            </Row>
          </Row>

          <Row style={{ marginBottom: 15, marginTop: -20 }}>
            <Col xs={24}>
              {condInformada ? (
                 <Button
                  onClick={this.onAdicionarClick}
                  style={{ float: "left", marginRight: 10, marginLeft: 15, width: 100 }}
                >
                  Adicionar
                </Button>
              ) : null}
              {formParcDisabled ? null : (
                <div>
                  <Button
                    className="botoesModalFormEditar"
                    htmlType="button"
                    onClick={this.onOKParcClick}
                    style={{ float: "right", marginRight: 10, marginLeft: 15, width: 150 }}
                  >
                    Salvar Parcela
                  </Button>

                  <Tooltip title="Voltar para Lista de Parcelas">
                    <Button
                      htmlType="button"
                      onClick={this.onCancelarParcClick}
                      style={{ float: "right", marginRight: 10, marginLeft: 15, width: 100 }}
                    >
                      Voltar
                    </Button>
                  </Tooltip>
                </div>
              )}
            </Col>
          </Row>

          <Row style={{}}>
            <div className="div-subTitulo" style={{ height: 30 }}>
              <span style={{ marginLeft: 10, fontWeight: "bold", fontSize: 17, paddingTop: -5 }}>
                Parcelas
              </span>
            </div>

            {vlrDifParc === 0 ? null : (
              <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
                <Col xs={24}>
                  <Col xs={24} sm={6}>
                    <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                    <span>{this.renderValor(valor_Total)}</span>
                  </Col>
                  <Col xs={24} sm={6}>
                    <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                    <span>{this.renderValor(vlrTotalParc)}</span>
                  </Col>
                  <Col xs={24} sm={6}>
                    <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                    <span>{this.renderValor(vlrDifParc)}</span>
                  </Col>
                </Col>
              </Row>
            )}
            <Table
              dataSource={listaParcelas}
              pagination={false}
              rowKey={(listaParcelas => listaParcelas.vp_parcela)}
            >
              <Column
                key="vp_parcela"
                dataIndex="vp_parcela"
                title="Parcela"
                width={60}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="vp_data_parcela"
                dataIndex="vp_data_parcela"
                title="Data Venc"
                width={80}
                align="center"
                className="listaCadastro"
                render={this.renderData}
              />
              <Column
                key="vp_valor_parcela"
                dataIndex="vp_valor_parcela"
                title="Valor Parc"
                render={this.renderValor}
                width={80}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title=""
                render={this.renderAcoesParcelas}
                width={40}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </Row>

          <ItemForm>
            <div className="divider-form" />
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={onFecharClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >

    );
  }
}


// WEBPACK FOOTER //
// ./src/components/TituloParcelaForm.js